import dayjs, { Dayjs } from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

export const formatToThaiDate = (date: Dayjs | string): string => {
  const normalizedDate =
    date instanceof Date
      ? date
      : typeof date === 'string'
      ? new Date(date)
      : date.toDate();

  return normalizedDate.toLocaleString('th', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};

export const getBuddhistYear = (year?: number): number => {
  if (year) return year + 543;
  return new Date().getFullYear() + 543;
};

export const convertBuddhistYearToGregorian = (year?: number): number => {
  if (year) return year - 543;
  return new Date().getFullYear();
};

export const formatDate = (date: Date, locale: string) => {
  const formatter = new Intl.DateTimeFormat(locale, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
  return formatter.format(new Date(date));
};

export const formatShortMonthYear = (date: Date, locale: string) => {
  const formatter = new Intl.DateTimeFormat(locale, {
    month: 'short',
    year: 'numeric',
  });
  return formatter.format(new Date(date));
};

export const formatYear = (date: Date, locale: string) => {
  const formatter = new Intl.DateTimeFormat(locale, {
    year: 'numeric',
  });
  return formatter.format(new Date(date)).replace('พ.ศ. ', '');
};

dayjs.extend(utc);
dayjs.extend(timezone);

export const formatToShortThaiDateTime = (
  date?: Dayjs | string | null
): string => {
  if (!date) return '-';

  try {
    const normalizedDate = dayjs(date).tz('Asia/Bangkok');
    if (!normalizedDate.isValid()) return '-';

    const thaiDate = normalizedDate.format('DD/MM');
    const buddhistYear = (normalizedDate.year() + 543).toString().slice(-2);
    const time = normalizedDate.format('HH:mm');

    return `${thaiDate}/${buddhistYear} ${time}`;
  } catch (error) {
    console.error('Error formatting date:', error);
    return '-';
  }
};

export const formatFullThaiDate = (date: Dayjs | null): string => {
  if (!date) {
    return '-';
  }

  return dayjs(date).format('D MMMM BBBB');
};
